<template>
  <IAlert
    v-if="showNoSoundAlert"
    color="warning"
  >
    <p>🔇 Ваш браузер блокирует звуковые уведомления.</p>
    <p>
      Пожалуйста, разрешите проигрывание звуковых уведомлений о выходе срочных материалов по
      <a
        :href="instructionLink"
        target="_blank"
      >инструкции</a>
    </p>
  </IAlert>
</template>

<script setup lang="ts">
import { IAlert } from '@inkline/inkline'
import {
  useSoundNotifications,
} from '@/ContextTab/modules/news/published/components/sound/useSoundNotifications'


const { showNoSoundAlert, instructionLink } = useSoundNotifications()
</script>
